import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAddSolid, LazySvgoAlign, LazySvgoAlignBottom, LazySvgoAlignCenterHor, LazySvgoAlignCenterVer, LazySvgoAlignLeft, LazySvgoAlignRight, LazySvgoAlignTop, LazySvgoArrowRight, LazySvgoAspectLaptop, LazySvgoAspectMobile, LazySvgoAspectSquad, LazySvgoBackground, LazySvgoBackward, LazySvgoBag, LazySvgoCheck, LazySvgoCheckCircle, LazySvgoCheckSmall, LazySvgoChevronDown, LazySvgoChevronLeftMedium, LazySvgoClock, LazySvgoClockSolid, LazySvgoCloseCircle, LazySvgoCloseSmall, LazySvgoCloudCheck, LazySvgoCloudError, LazySvgoCollapse, LazySvgoColorPicker, LazySvgoCornerArrow, LazySvgoCrown, LazySvgoCursor, LazySvgoDotsHorizontal, LazySvgoDotsVertical, LazySvgoDownload, LazySvgoDuplicate, LazySvgoEdit, LazySvgoEditOutline, LazySvgoEmpty, LazySvgoExclamationMarkCircle, LazySvgoExit, LazySvgoExpand, LazySvgoExpandAlt, LazySvgoExpandSmall, LazySvgoFigures, LazySvgoFileText, LazySvgoFilm, LazySvgoFolder, LazySvgoForward, LazySvgoHand, LazySvgoHelp, LazySvgoImage, LazySvgoImport, LazySvgoInfoCircle, LazySvgoInputEdit, LazySvgoLaptop, LazySvgoLayers, LazySvgoLogout, LazySvgoMessageFace, LazySvgoMinusSmall, LazySvgoMobile, LazySvgoMusic, LazySvgoNoImage, LazySvgoPause, LazySvgoPlay, LazySvgoPlayOutlineBig, LazySvgoPlayOutlineMedium, LazySvgoPlayOutlineSmall, LazySvgoPlus, LazySvgoPlusCircle, LazySvgoPlusSmall, LazySvgoQuestionCircle, LazySvgoRedo, LazySvgoSource, LazySvgoStackBack, LazySvgoStackBackward, LazySvgoStackForward, LazySvgoStackFront, LazySvgoStop, LazySvgoTextFrame, LazySvgoTranslate, LazySvgoTrashCan, LazySvgoUndo, LazySvgoUpload, LazySvgoUploadAlt, LazySvgoUploadSolid, LazySvgoUserCircle, LazySvgoVideo, LazySvgoWizard, LazySvgoZoomIn, LazySvgoZoomOut } from '#components'
const lazyGlobalComponents = [
  ["SvgoAddSolid", LazySvgoAddSolid],
["SvgoAlign", LazySvgoAlign],
["SvgoAlignBottom", LazySvgoAlignBottom],
["SvgoAlignCenterHor", LazySvgoAlignCenterHor],
["SvgoAlignCenterVer", LazySvgoAlignCenterVer],
["SvgoAlignLeft", LazySvgoAlignLeft],
["SvgoAlignRight", LazySvgoAlignRight],
["SvgoAlignTop", LazySvgoAlignTop],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoAspectLaptop", LazySvgoAspectLaptop],
["SvgoAspectMobile", LazySvgoAspectMobile],
["SvgoAspectSquad", LazySvgoAspectSquad],
["SvgoBackground", LazySvgoBackground],
["SvgoBackward", LazySvgoBackward],
["SvgoBag", LazySvgoBag],
["SvgoCheck", LazySvgoCheck],
["SvgoCheckCircle", LazySvgoCheckCircle],
["SvgoCheckSmall", LazySvgoCheckSmall],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeftMedium", LazySvgoChevronLeftMedium],
["SvgoClock", LazySvgoClock],
["SvgoClockSolid", LazySvgoClockSolid],
["SvgoCloseCircle", LazySvgoCloseCircle],
["SvgoCloseSmall", LazySvgoCloseSmall],
["SvgoCloudCheck", LazySvgoCloudCheck],
["SvgoCloudError", LazySvgoCloudError],
["SvgoCollapse", LazySvgoCollapse],
["SvgoColorPicker", LazySvgoColorPicker],
["SvgoCornerArrow", LazySvgoCornerArrow],
["SvgoCrown", LazySvgoCrown],
["SvgoCursor", LazySvgoCursor],
["SvgoDotsHorizontal", LazySvgoDotsHorizontal],
["SvgoDotsVertical", LazySvgoDotsVertical],
["SvgoDownload", LazySvgoDownload],
["SvgoDuplicate", LazySvgoDuplicate],
["SvgoEdit", LazySvgoEdit],
["SvgoEditOutline", LazySvgoEditOutline],
["SvgoEmpty", LazySvgoEmpty],
["SvgoExclamationMarkCircle", LazySvgoExclamationMarkCircle],
["SvgoExit", LazySvgoExit],
["SvgoExpand", LazySvgoExpand],
["SvgoExpandAlt", LazySvgoExpandAlt],
["SvgoExpandSmall", LazySvgoExpandSmall],
["SvgoFigures", LazySvgoFigures],
["SvgoFileText", LazySvgoFileText],
["SvgoFilm", LazySvgoFilm],
["SvgoFolder", LazySvgoFolder],
["SvgoForward", LazySvgoForward],
["SvgoHand", LazySvgoHand],
["SvgoHelp", LazySvgoHelp],
["SvgoImage", LazySvgoImage],
["SvgoImport", LazySvgoImport],
["SvgoInfoCircle", LazySvgoInfoCircle],
["SvgoInputEdit", LazySvgoInputEdit],
["SvgoLaptop", LazySvgoLaptop],
["SvgoLayers", LazySvgoLayers],
["SvgoLogout", LazySvgoLogout],
["SvgoMessageFace", LazySvgoMessageFace],
["SvgoMinusSmall", LazySvgoMinusSmall],
["SvgoMobile", LazySvgoMobile],
["SvgoMusic", LazySvgoMusic],
["SvgoNoImage", LazySvgoNoImage],
["SvgoPause", LazySvgoPause],
["SvgoPlay", LazySvgoPlay],
["SvgoPlayOutlineBig", LazySvgoPlayOutlineBig],
["SvgoPlayOutlineMedium", LazySvgoPlayOutlineMedium],
["SvgoPlayOutlineSmall", LazySvgoPlayOutlineSmall],
["SvgoPlus", LazySvgoPlus],
["SvgoPlusCircle", LazySvgoPlusCircle],
["SvgoPlusSmall", LazySvgoPlusSmall],
["SvgoQuestionCircle", LazySvgoQuestionCircle],
["SvgoRedo", LazySvgoRedo],
["SvgoSource", LazySvgoSource],
["SvgoStackBack", LazySvgoStackBack],
["SvgoStackBackward", LazySvgoStackBackward],
["SvgoStackForward", LazySvgoStackForward],
["SvgoStackFront", LazySvgoStackFront],
["SvgoStop", LazySvgoStop],
["SvgoTextFrame", LazySvgoTextFrame],
["SvgoTranslate", LazySvgoTranslate],
["SvgoTrashCan", LazySvgoTrashCan],
["SvgoUndo", LazySvgoUndo],
["SvgoUpload", LazySvgoUpload],
["SvgoUploadAlt", LazySvgoUploadAlt],
["SvgoUploadSolid", LazySvgoUploadSolid],
["SvgoUserCircle", LazySvgoUserCircle],
["SvgoVideo", LazySvgoVideo],
["SvgoWizard", LazySvgoWizard],
["SvgoZoomIn", LazySvgoZoomIn],
["SvgoZoomOut", LazySvgoZoomOut],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
